// extracted by mini-css-extract-plugin
export default {"nameAddressHeader":"DaterProfileView_nameAddressHeader__PZsGo","name":"DaterProfileView_name__wbHOQ","ageAddress":"DaterProfileView_ageAddress__e-fUM"};